import Model, { attr, belongsTo } from '@ember-data/model';

class ScheduledEmployee extends Model {
  @belongsTo('employee', { async: true, inverse: null }) employee;
  @belongsTo('user', { async: true, inverse: null }) user;

  @attr('string') email;
  @attr('string') name;
  @attr('date') date;
  @attr('boolean') scheduled;
  @attr('string') profilePictureUrl;
}

export default ScheduledEmployee;
